import styled from 'styled-components'
import { Typography } from '@chegg-ui/typography'
import { font, spacing, colors } from '@chegg-ui/theme'

export const ModalScreenHeading = styled(Typography).attrs({
  variant: 'h1',
  variantType: 'bold',
})`
  font-size: ${font.size.px22};
  line-height: ${font.lineHeight.md};
  margin-top: 17px;
  font-weight: 700px;
  text-align: center;
  span {
    color: ${colors.orange900};
  }
`

export const ModalScreenSubheading = styled.div`
  font-size: ${font.size.px14};
  line-height: ${font.lineHeight.md};
  text-align: center;
  margin: ${spacing.px32} ${spacing.px24} 0;
`

export const ModalScreenContent = styled.div`
  font-size: ${font.size.px12};
  line-height: ${font.lineHeight.md};
  margin-top: 76px;
  text-align: center;
`

export const ModalScreenContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${spacing.px4} ${spacing.px32};
  max-width: 372px;
  margin: auto;
`

export const ModalScreenAnimation = styled.div`
  margin-top: 51px;
`

export const MarginLeft = styled.div`
  margin-left: 5px;
`
